import React, { Component } from 'react';
import { ServiceLogin } from "../../service/Login";
import { ComponentsAppSplash } from "../../components/App/Splash";
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { withNamespaces } from 'react-i18next';

class ScreensAdminLogin extends Component {




    constructor() {
        super();
        this.state = {
            splash: false,
            erroLogin: false,
            mensagemErro: "",
            transicaoSaida: false,
            loadingLogin: false,
            usuario: "",
            senha: ""
        };

        this.serviceLogin = new ServiceLogin();
        this.redirectTimeout = null;
    }

    componentWillUnmount() {
        if (this.redirectTimeout) {
            clearTimeout(this.redirectTimeout);
        }
    }

    handleLoginClick() {
        const { usuario, senha } = this.state;

        if (!usuario || !senha) {
            this.setState({
                erroLogin: true,
                mensagemErro: this.props.t("SCREENS.ADMIN_LOGIN.REQUIRED")
            });
            return;
        }

        this.setState({ erroLogin: false, mensagemErro: "", loadingLogin: true });

        this.handleExecute({ usuario, senha });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.handleLoginClick();
    }


    async handleExecute(e) {
        try {
            const response = await this.serviceLogin.login(e.usuario, e.senha);

            const acoes = Array.isArray(response?.Acoes) ? response.Acoes : [];
            const temAcessoConfigPortal = acoes.some((acao) => {
                if (typeof acao === "string") {
                    return acao === "acessoConfigPortal";
                }

                const atributo = acao?.Atributo || acao?.atributo || acao?.Acao || acao?.acao;
                return atributo === "acessoConfigPortal";
            });

            if (!temAcessoConfigPortal) {
                this.setState({
                    erroLogin: true,
                    mensagemErro: this.props.t("SCREENS.ADMIN_LOGIN.NO_PERMISSION")
                });
                ServiceLogin.logout();
                return;
            }

            sessionStorage.setItem("auth", JSON.stringify(response));

            this.setState({ transicaoSaida: true, loadingLogin: false });
            this.redirectTimeout = setTimeout(() => {
                window.location = "#/admin/config";
            }, 550);
            return;
        } catch (err) {
            console.error("Erro no login admin:", err);
            this.setState({
                erroLogin: true,
                mensagemErro: this.props.t("SCREENS.ADMIN_LOGIN.INVALID")
            });
        } finally {
            this.setState({ splash: false, loadingLogin: false });
        }
    }


    render() {
        const { t } = this.props;

        return (
            <div
                className={`admin-login-transition-wrapper ${this.state.transicaoSaida ? 'admin-login-transition-wrapper--leave' : ''}`}
                style={{
                    minHeight: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#f8f9fa"
                }}
            >
                <ComponentsAppSplash visible={this.state.splash} />

                <div
                    style={{
                        width: "34.5vi",
                        minHeight: "300px",
                        padding: "30px",
                        borderRadius: "12px",
                        background: "#fff",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
                    }}>

                    <form className="login-page__form--loginAdmin" onSubmit={this.handleSubmit}>
                        <div>
                            <div style={{ marginTop: '10px' }}>
                                <label className="login-page__label">{t("SCREENS.ADMIN_LOGIN.USER")}</label>
                            </div>
                            <InputText
                                id="textLogin"
                                className={`login-page__input--loginAdmin ${this.state.erroLogin ? 'login-page__input--login--error' : ''}`}
                                value={this.state.usuario}
                                onChange={(e) => this.setState({ usuario: e.target.value })}
                            />
                        </div>

                        <div>
                            <div style={{ marginTop: '20px', position: 'relative' }}>
                                <label className="login-page__label">{t("SCREENS.ADMIN_LOGIN.PASSWORD")}</label>
                            </div>
                            <span
                                className={this.state.erroLogin ? 'login-page__control--password' : ''}>
                                <Password
                                    className="login-page__input--password--loginAdmin"
                                    id="senha"
                                    value={this.state.senha}
                                    onChange={(e) => this.setState({ senha: e.target.value })}
                                    feedback={false}
                                    toggleMask

                                />
                            </span>
                        </div>

                        {this.state.erroLogin && this.state.mensagemErro && (
                            <p className="login-page__error-message" style={{ marginTop: '12px' }}>
                                {this.state.mensagemErro}
                            </p>
                        )}

                        <div className="login-page__button--loginAdmin">
                            <Button
                                id="btnLogin"
                                className="btn-alinhado--loginAdmin"
                                type="submit"
                                disabled={this.state.loadingLogin}
                            >
                                {this.state.loadingLogin ? (
                                    <>
                                        <i className="pi pi-spin pi-spinner login-btn-icon" style={{ marginRight: '8px' }} />
                                        {t("SCREENS.ADMIN_LOGIN.LOADING")}
                                    </>
                                ) : (
                                    <>
                                        <span>{t("AUTH.BUTTON.ACESSAR_EXAMES")}</span>
                                        <i className="pi pi-angle-right icone-do-botao" />
                                    </>
                                )}
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default withNamespaces()(ScreensAdminLogin);
